module.exports = __webpack_public_path__ + "img/phone-w.6ee58acd.svg";